import request from '@/util/request';
import qs from 'qs';

export const getPayBillLogDetailsList = (params, options) =>
  request.get('/api/v4ward/pay/payBillLogDetails/page', Object.assign({}, options, { params }));
